// Auth Zod schemas — FE/BE'nin aynı shape'i kullanması için.
// Plan §4.1 ekranları + ADR-002 S4 CSRF.

import { z } from "zod";
import { ClientAdminMembershipSchema } from "./client-admin.js";

export const LoginRequestSchema = z.object({
  email: z.string().email("Geçerli bir email girin"),
  password: z.string().min(1, "Şifre gerekli"),
});
export type LoginRequest = z.infer<typeof LoginRequestSchema>;

export const ForgotPasswordRequestSchema = z.object({
  email: z.string().email(),
});
export type ForgotPasswordRequest = z.infer<typeof ForgotPasswordRequestSchema>;

export const ResetPasswordRequestSchema = z.object({
  token: z.string().min(8),
  password: z.string().min(12, "Şifre en az 12 karakter olmalı"),
});
export type ResetPasswordRequest = z.infer<typeof ResetPasswordRequestSchema>;

// First-login = aktivasyon. Token + password aynı shape.
export const FirstLoginRequestSchema = ResetPasswordRequestSchema;
export type FirstLoginRequest = z.infer<typeof FirstLoginRequestSchema>;

// Davet/sıfırlama bağlantısı ön kontrolü — POST /auth/activation-status gövde {token} (2026-10-20).
// POST: token sorgu dizesinde olsaydı pino `req.url` + Caddy erişim logunda kalırdı; gövde loglanmaz.
// Yanıt hesap bilgisi taşımaz; `kind` yalnız aktif (valid/expired) token'da döner.
export const ACTIVATION_STATUSES = ["valid", "used", "expired", "invalid"] as const;
export type ActivationStatus = (typeof ACTIVATION_STATUSES)[number];

export const ActivationStatusRequestSchema = z.object({
  token: z.string().min(1).max(256),
});
export type ActivationStatusRequest = z.infer<typeof ActivationStatusRequestSchema>;

export const ActivationStatusResponseSchema = z.object({
  status: z.enum(ACTIVATION_STATUSES),
  kind: z.enum(["first_login", "reset"]).optional(),
});
export type ActivationStatusResponse = z.infer<typeof ActivationStatusResponseSchema>;

export const AuthUserResponseSchema = z.object({
  id: z.string().uuid(),
  email: z.string().email(),
  fullName: z.string(),
  roleId: z.string().uuid(),
  roleName: z.string(),
  permissions: z.record(z.string(), z.boolean()),
  // Müşteri katılımcı rolü — FE yönlendirme (client route seti) bunu okur.
  userKind: z.enum(["internal", "client"]),
  // KPI M16 (K13, Δ1/C12): yöneticisi olduğu müşteri firmalar (`client_admins` aktif satırları).
  // FE `/auth/me`'yi Zod ile parse etmez (RK23) — alan yalnız taşınır; iç kullanıcıda [].
  adminClientIds: z.array(z.string().uuid()).default([]),
  // Portal yetki v2 (Y5) — aynı üyelikler rol + Admin kapsamıyla (`adminClientIds` korunur).
  adminClients: z.array(ClientAdminMembershipSchema).default([]),
});
export type AuthUserResponse = z.infer<typeof AuthUserResponseSchema>;

export const LoginResponseSchema = z.object({
  user: AuthUserResponseSchema,
  csrfToken: z.string(),
});
export type LoginResponse = z.infer<typeof LoginResponseSchema>;
